// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__22BBd","bigColWidth":"Table_bigColWidth__2LxtY","biggerColWidth":"Table_biggerColWidth__2o42E","row":"Table_row__3jq5i","col":"Table_col__2jBeK"};